var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZdirect(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_2341_2875)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.66682 9.81577C5.71779 9.92934 5.66705 10.0627 5.55348 10.1137C5.05729 10.3364 4.67176 10.5909 4.41337 10.8597C4.15604 11.1273 4.03478 11.3976 4.03478 11.6617C4.03478 12.1063 4.3857 12.5748 5.11798 12.9902C5.83833 13.3989 6.86934 13.7194 8.08362 13.8867C8.20694 13.9037 8.29313 14.0175 8.27614 14.1408C8.25914 14.2641 8.1454 14.3503 8.02208 14.3333C6.77143 14.161 5.68071 13.8277 4.89555 13.3823C4.12234 12.9437 3.58398 12.3579 3.58398 11.6617C3.58398 11.2485 3.77611 10.872 4.08841 10.5472C4.39966 10.2235 4.84004 9.93981 5.36888 9.70244C5.48245 9.65146 5.61584 9.7022 5.66682 9.81577ZM14.6984 9.97926C14.7574 9.86968 14.8941 9.82872 15.0037 9.88778C15.8305 10.3334 16.4116 10.938 16.4116 11.6617C16.4116 12.0962 16.1992 12.4897 15.858 12.8258C15.5176 13.1612 15.0365 13.4528 14.4603 13.6928C13.3068 14.1734 11.729 14.4653 9.99777 14.4653C9.94707 14.4653 9.89652 14.4651 9.8461 14.4646C9.72162 14.4634 9.62171 14.3615 9.62294 14.237C9.62417 14.1125 9.72607 14.0126 9.85055 14.0138C9.89948 14.0143 9.94856 14.0145 9.99777 14.0145C11.6843 14.0145 13.2006 13.7293 14.2869 13.2767C14.8306 13.0502 15.2558 12.7863 15.5417 12.5047C15.8268 12.2239 15.9608 11.9391 15.9608 11.6617C15.9608 11.1988 15.5798 10.7104 14.7898 10.2846C14.6803 10.2256 14.6393 10.0888 14.6984 9.97926Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.16769 15.0185C7.21944 15.1102 7.33498 15.1411 7.42581 15.0876L8.59422 14.3974C8.68488 14.3437 8.71648 14.2258 8.66476 14.1341L7.99802 12.9522C7.94614 12.8603 7.83059 12.8293 7.73989 12.883C7.64911 12.9365 7.61752 13.0544 7.66935 13.1463L8.24235 14.162L7.23826 14.7551C7.14746 14.8087 7.11586 14.9266 7.16769 15.0185L7.16769 15.0185Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.18148 12V10.8049L10.6279 6.54834H7.57088V5.43831H12.3735V6.46777L8.77938 10.8944H12.5123V12H7.18148Z",
    fill: "#EEEEEE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_2341_2875",
    x: -4,
    y: -4,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2341_2875"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2341_2875",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZdirect);
export default __webpack_public_path__ + "static/media/zdirect.b188ca5b0fb80beb27311bf4e285914f.svg";
export { ForwardRef as ReactComponent };